import { Direction } from './../../../logic/graphql/types/types.d';
import { Status } from '../../../logic/graphql/types/types';

export enum DataVariant {
  default,
  highlighted,
  gray,
  descriptive_highlighted,
}

export type ListItemDataRow = {
  label: string;
  value: string;
  variant?: DataVariant;
};

export type ListItemDataBlock = {
  dataLines: readonly ListItemDataRow[];
};

export type ListItemData = {
  status: Status;
  iconVisible?: boolean;
  title: string;
  titleExtension?: string;
  transactionCode?: string;
  detailBlocks: readonly ListItemDataBlock[];
  date: string;
  direction?: Direction;
};
